import { render, staticRenderFns } from "./MasterClassDetails.vue?vue&type=template&id=52c828d6&"
import script from "./MasterClassDetails.vue?vue&type=script&lang=js&"
export * from "./MasterClassDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports